import { GET_APPOINTMENTS_TABLE_FAILURE, GET_APPOINTMENTS_TABLE_REQUEST, GET_APPOINTMENTS_TABLE_SUCCESS } from "../constants/appointmentRecordConstants"



export const getAppointmentsTableRequest = (data) => ({ type: GET_APPOINTMENTS_TABLE_REQUEST, data })
export const getAppointmentsTableSuccess = (data) => ({ type: GET_APPOINTMENTS_TABLE_SUCCESS, data })
export const getAppointmentsTableFailure = (error) => ({ type: GET_APPOINTMENTS_TABLE_FAILURE, payload: error })

export const STOP_ALL_LOADING = 'STOP_ALL_LOADING'

export const stopAllLoading = () => ({ type: STOP_ALL_LOADING })


